import { relation, text, writer } from '@nozbe/watermelondb/decorators';
import { BUSINESS_CARD_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class BusinessCard extends Model {
    static table = BUSINESS_CARD_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' }
    }

    @text('business_category') business_category;
    @text('business_name') business_name;
    @text('phone_number') phone_number;
    @text('contact_name') contact_name;
    @text('about_us') about_us;
    @text('address') address;
    @text('email') email;

    @relation('business', 'business_id') business;

    @writer async updateCard(details) {
        await this.update(card => {
            card.business_name = details.business_name
            card.phone_number = details.phone_number
            card.business_category = details.business_category
            card.address = details.address
            card.email = details.email
            card.about_us = details.about_us
            card.contact_name = details.contact_name
        })
    }
}